export type FileStatus = 'rejected';

export const FILE_EXTENSION_MAPPING = {
    word: ['doc', 'docx', 'odt'] as const,
    excel: ['xls', 'xlsx', 'ods'] as const,
    pdf: ['pdf'] as const,
    image: ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg', 'tiff', 'heic', 'heif'] as const,
    unknown: ['*'],
} as const;

export type SupportedFileExtensions = (typeof FILE_EXTENSION_MAPPING)[keyof typeof FILE_EXTENSION_MAPPING][number];
export type FileTypes = keyof typeof FILE_EXTENSION_MAPPING;
export type SimpleFileType = 'image' | 'pdf' | 'other';

export function getFileTypeFromName(fileName: string): FileTypes {
    if (fileName) {
        for (const extension in FILE_EXTENSION_MAPPING) {
            const parts = fileName.split('.');
            const ext = parts.length > 1 ? parts.pop().toLowerCase() : '';
            if (FILE_EXTENSION_MAPPING[extension].includes(ext)) {
                return extension as FileTypes;
            }
        }
    }

    return 'unknown';
}

export function getSimpleFileTypeFromName(fileName: string): SimpleFileType {
    switch (getFileTypeFromName(fileName)) {
        case 'image':
            return 'image';
        case 'pdf':
            return 'pdf';
        default:
            return 'other';
    }
}

export interface FileInterface {
    _id?: string;
    createdAt?: Date;
    isDeliveredByUs?: boolean;
    isHidden?: boolean;
    isJoined?: boolean;
    joinedFiles?: Omit<FileInterface, 'isJoined' | 'parent' | 'joinedFiles'>[];
    name: string;
    parent?: string;
    path: string;
    rejectionReason?: string;
    size?: number;
    status?: FileStatus | null;
    type?: SimpleFileType;
}

export class NewlyUploadedFile implements FileInterface {
    public createdAt: Date;
    public type: SimpleFileType = 'other';

    public constructor(
        public name: string,
        public path: string,
        public size: number
    ) {
        this.createdAt = new Date();
        this.type = getSimpleFileTypeFromName(name);
    }
}
